export const PWA_INSTALL_PROMPT_READY_EVENT = "aevo:pwa-install-prompt-ready";
export const PWA_APP_INSTALLED_EVENT = "aevo:pwa-app-installed";

const INSTALL_STORE_KEY = "__aevoPwaInstallStore";

function getInstallStore() {
  if (typeof window === "undefined") return null;
  window[INSTALL_STORE_KEY] ||= {
    deferredPrompt: null,
    isListenerReady: false,
  };
  return window[INSTALL_STORE_KEY];
}

export function isStandalonePwa() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator?.standalone === true
  );
}

export function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  return /android|iphone|ipad|ipod/i.test(navigator.userAgent || "");
}

export function isIosDevice() {
  if (typeof navigator === "undefined") return false;
  const userAgent = navigator.userAgent || "";
  return /iphone|ipad|ipod/i.test(userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

export function setupPwaInstallPromptListener() {
  if (typeof window === "undefined") return;

  const store = getInstallStore();
  if (!store || store.isListenerReady) return;
  store.isListenerReady = true;

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    store.deferredPrompt = event;
    window.dispatchEvent(new Event(PWA_INSTALL_PROMPT_READY_EVENT));
  });

  window.addEventListener("appinstalled", () => {
    store.deferredPrompt = null;
    window.dispatchEvent(new Event(PWA_APP_INSTALLED_EVENT));
  });
}

export function getDeferredInstallPrompt() {
  return getInstallStore()?.deferredPrompt || null;
}

export function clearDeferredInstallPrompt() {
  const store = getInstallStore();
  if (store) store.deferredPrompt = null;
}

export function registerPwaServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (import.meta.env.MODE === "test") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((error) => {
        console.warn("Aevo service worker registration failed:", error?.message || error);
      });
  });
}
